import { Spin } from "antd";

export default function overLoader() {
  return (
    <div className="loader">
      <Spin size="large" />
    </div>
  );
}
